import axios from "axios";
import {showGlobalMessage} from "../components/GlobalMessage/actions/showGlobalMessage";
import {messages as M} from "../../../../_metronic/i18n/messages";

export const FIND_CUSTOMER = "/customers/findCustomer";

export const findCustomer = (input) => dispatch => {

  return axios.post(FIND_CUSTOMER, {input})
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) {
        dispatch(showGlobalMessage('error', M[errorCode]))
      }

      return {options: body.customers};
    })
    .catch((err) => {
      console.error(err)
      dispatch(showGlobalMessage('error', M['-1']))
    });
};
